<script>
import forminput from "../formcomponet/forminput.vue";
import formcombobox from "../formcomponet/formcombobox.vue";
import formdate from "../formcomponet/formdate.vue";
import formcheckbox from "../formcomponet/formcheckbox.vue";
import formtextarea from "../formcomponet/formtextarea.vue";
import BirimSecimi from "../formcomponet/BirimSecimiAnaBirim.vue";
import Loader from "@/components/widgets/loader";
import apibtoast from "@/helpers/apibtoast";
import apigeneric from "@/helpers/apigeneric";
import satdosya from "@/models/satdosya";
import moment from "moment";
import Treeselect from "@riophae/vue-treeselect";
import store from "@/state/store";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { ASYNC_SEARCH } from '@riophae/vue-treeselect'
const simulateAsyncOperation = fn => {
  setTimeout(fn, 500)
}
export default {
  mixins: [apibtoast, apigeneric, satdosya],
  props: ["Id", "AddEdit"],
  data() {
    return {
      FormData: {},
      eskiihaleturu: null,
      file: "",
      hedefiid: "",
      faaliyetid: "",
      harcamagirisData: {},
      ekapNo: false,
      aktif_arama: false,
      aktif_arama2: false,
      AmacSiralama: [],
      VeriGirisPersonelid: null
    };
  },
  components: {
    Loader,
    forminput,
    formcombobox,
    formdate,
    formcheckbox,
    formtextarea,
    BirimSecimi,
    Treeselect

  },
  watch: {
    Id() {
      this.FormData = this.Id;
      let Page = {
        PageNumber: "1",
        PageSize: "50",
      };
      if (this.AddEdit == "Edit") {
        this.ActionsFilterGet({ Service: "StrBirimButceHarcamalari", Page: Page, Filter: "&Satdosyaid=" + this.Id.Id }).then((res) => {
          this.harcamagirisData = res.Data[0];
        });

      }
      this.eskiihaleturu = this.FormData.ihaleturu

      if (this.AddEdit == "Add") {

        this.aktif_arama = true;
        this.aktif_arama2 = true;


      } else {
        if (18 == this.Id.ihaleturukod || 21 == this.Id.ihaleturukod || this.Id.ihaleturukod == 9 || this.Id.ihaleturukod == 10 ||
          11 == this.Id.ihaleturukod || this.Id.ihaleturukod == 12 || this.Id.ihaleturukod == 13 ||
          14 == this.Id.ihaleturukod || this.Id.ihaleturukod == 15 || this.Id.ihaleturukod == 16 || 17 == this.Id.ihaleturukod || 19 == this.Id.ihaleturukod || 20 == this.Id.ihaleturukod) {
          this.ekapNo = false;
        } else {
          this.ekapNo = true;
        }
        this.FormDataType.gerceklestirmegorevlisiid.ComboDataArray.push({ id: this.FormData.gerceklestirmegorevlisiid, label: this.FormData.gerceklestirme });
        this.FormDataType.harcamagorevlisiid.ComboDataArray.push({ id: this.FormData.harcamagorevlisiid, label: this.FormData.harcamagorevlisi });

        if (this.Id.hesapkodu) {

          this.aktif_arama = false;

          this.liste_kontrol();
        }

        if (this.Id.hesapkodu2) {

        this.aktif_arama2 = false;

        this.liste_kontrol2();
        }


        (this.hedefiid = this.FormData.hedefiid), (this.faaliyetid = this.FormData.faaliyetid);
        this.HedefSecimi();
        (this.FormData.hedefiid = this.hedefiid),


          this.FaaliyetSecimi();
        this.FormData.faaliyetid = this.faaliyetid;

        this.AmacSecimi(this.FormData.strperfdonem)




      }
      setTimeout(() => {


        this.aktif_arama = true;
        this.aktif_arama2 = true;

      }, 200);

               this.ActionsFilterGet({Service:"Opersonel/GetAllPersonel", Page:Page, Filter:"&Eposta="+this.UserEmail}).then((res) => {
            if(res){
              this.VeriGirisPersonelid=res.Data[0].Id;
            }

          });
    },
  },
  created() {
    this.KullaniciBilgileri = store.getters.["auth/UserRolles"];
      this.UserEmail = store.getters.["auth/UserEMail"] 


  },
  methods: {
    onSubmit() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        //this.$delete(this.FormData, "muayenekabulkomisyonu");
        if (this.FormData.yaklasikmaliyetwebsite) {
          this.FormData.websiteverigirislink =
            window.location.protocol + "//" +
            window.location.host +
            "/yaklasikmaliyetgiris/"
        }
        this.ActionsSingleGet({
          Service: "okeyvalues",
          Id: this.FormData.ihaleturu,
        }).then((res) => {
          if (this.eskiihaleturu != this.FormData.ihaleturu) {



            if (res.Data.Kod == 1) {
              this.FormData.dosyamenu = { "1100": false, "1200": false, "1300": false, "3100": false, "3200": false, "3310": false, "3320": false, "3330": false, "3410": false }
            }
            else if (
              res.Data.Kod == 9 ||
              res.Data.Kod == 10 ||
              res.Data.Kod == 11 ||
              res.Data.Kod == 12 ||
              res.Data.Kod == 13 ||
              res.Data.Kod == 14 ||
              res.Data.Kod == 15 ||
              res.Data.Kod == 16 ||
              res.Data.Kod == 17 ||
              res.Data.Kod == 18 ||
              res.Data.Kod == 21 ||
              res.Data.Kod == 19 ||
              res.Data.Kod == 20

            ) {
              this.FormData.dosyamenu = { "1100": false, "1200": false, "1300": false, "2100": false, "4100": false }
            }
            else {
              this.FormData.dosyamenu = { "1100": false, "1200": false, "1300": false, "3100": false, "3200": false, "3310": false, "3320": false, "3330": false, "3410": false }
            }
            this.FormData.dosyamenu = JSON.stringify(this.FormData.dosyamenu)

          }


          if (this.AddEdit == "Add") {

            this.Post("satdosya", this.FormData).then((res) => {
              if (res) {
                this.$emit("TableUpdate");
                console.log(res);
                this.$bvModal.hide("satdosya");
                this.harcamagirisData.Isintanimi = this.FormData.dosyaadi,
                  this.harcamagirisData.Butcetertibi = this.FormData.hesapkodu,
                  this.harcamagirisData.Tarih = this.FormData.dosyaacilistarih,
                  this.harcamagirisData.Donem = moment(String(this.FormData.dosyaacilistarih)).format("YYYY"),
                  this.harcamagirisData.Aciklama = this.FormData.alimnedeni,
                  this.harcamagirisData.Onay = false, //bu yok
                  this.harcamagirisData.Duzeltmenotu = "string",
                  this.harcamagirisData.Sira = 0,
                  this.harcamagirisData.Baslik = this.FormData.dosyaadi,
                  this.harcamagirisData.Birimid = this.FormData.ihaleyiyapanmakam,
                  this.harcamagirisData.Strperfdonemid = this.FormData.strperfdonem,
                  this.harcamagirisData.Gerceklestirmegorevlisiid = this.FormData.gerceklestirmegorevlisiid,
                  this.harcamagirisData.Harcamayetkilisid = this.VeriGirisPersonelid,
                  this.harcamagirisData.Harcamatipiid = this.FormData.alimturu,
                  this.harcamagirisData.Ihaleusulleriid = this.FormData.ihaleturu,
                  this.harcamagirisData.Stramacid = this.FormData.amacid,
                  this.harcamagirisData.Strperformanshedefiid = this.FormData.hedefiid,
                  this.harcamagirisData.Strtabdetfaaliyetid = this.FormData.faaliyetid,
                  this.harcamagirisData.Butcedisi = this.FormData.butcedisi,
                  this.harcamagirisData.Satdosyaid = res;
         /*       if (this.FormData.ekapno == null || this.FormData.ekapno == "") {
                  this.Post("StrBirimButceHarcamalari", this.harcamagirisData).then((res) => {
                    if (res) {
                      this.$emit("TableUpdate");
                    }
                  });
                }*/



              }
            });

          } else {
            this.Update("satdosya", this.FormData).then((res) => {
              if (res) {
                this.$emit("TableUpdate");
                this.$bvModal.hide("satdosya");
                this.harcamagirisData.Tarih = this.FormData.dosyaacilistarih,
                  this.harcamagirisData.Donem = moment(String(this.FormData.dosyaacilistarih)).format("YYYY"),
                  this.harcamagirisData.Aciklama = this.FormData.alimnedeni,
                  this.harcamagirisData.Onay = false, //bu yok
                  this.harcamagirisData.Duzeltmenotu = "string",
                  this.harcamagirisData.Sira = 0,
                  this.harcamagirisData.Baslik = this.FormData.dosyaadi,
                  this.harcamagirisData.Birimid = this.FormData.ihaleyiyapanmakam,
                  this.harcamagirisData.Strperfdonemid = this.FormData.strperfdonem,
                  this.harcamagirisData.Gerceklestirmegorevlisiid = this.FormData.gerceklestirmegorevlisiid,
                  this.harcamagirisData.Harcamayetkilisid = this.VeriGirisPersonelid,
                  this.harcamagirisData.Harcamatipiid = this.FormData.alimturu,
                  this.harcamagirisData.Ihaleusulleriid = this.FormData.ihaleturu,
                  this.harcamagirisData.Stramacid = this.FormData.amacid,
                  this.harcamagirisData.Strperformanshedefiid = this.FormData.hedefiid,
                  this.harcamagirisData.Strtabdetfaaliyetid = this.FormData.faaliyetid,
                  this.harcamagirisData.Butcedisi = this.FormData.butcedisi;
            /*    if (this.FormData.ekapno == null || this.FormData.ekapno == "" || this.FormData.tamamlandi == false) {
                  this.Update("StrBirimButceHarcamalari", this.harcamagirisData).then((res) => {
                    if (res) {
                      this.$emit("TableUpdate");
                    }
                  });
                }*/

              }
            });
          }
        })


      }
    },
    Get() {

    },
    FileUpload() {
      this.file = this.$refs.file.files[0];
      let x = this.file.name;
      //this.FormData.Filename = this.file.name;
      this.uzanti = x.substr(
        x.lastIndexOf(".") + 1,
        x.length - x.lastIndexOf(".")
      );
      if (this.uzanti == 'pdf' || this.uzanti == 'doc' || this.uzanti == 'xlsx' || this.uzanti == 'dwg') {
        let formData = new FormData();
        formData.append("file", this.file);
        this.ActionsPost({
          Service: "GenericFileUpDownload/UploadFile?pathUrl=Sat",
          Data: formData,
        }).then((res) => {
          if (res.Succeeded == true) {
            this.FormData.dosyamalzemebelge = res.Data.filename;
            this.$toast.success(this.$t("ToasMessage.FilePozitif"));

          } else {
            this.$toast.error(this.$t("ToasMessage.FileNegatif"));
          }
        });
      } else {
        this.$toast.error(this.$t("ToasMessage.FileNegatifUzanti"));
      }
    },
    loadOptions2({ action, callback }) {
      this.options = [];
      if (action === ASYNC_SEARCH) {
        simulateAsyncOperation(() => {

          this.options = this.user;

          callback(null, this.options)
        })
      }
    },
    user_yukle(veri) {
      let Page = {
        PageNumber: "1",
        PageSize: "100",
      };

      if (veri.length >= 1) {
        this.user = [];
        let Filter = "&Adsoyad=" + veri;

        this.ActionsFilterGet({
          Service: "OPersonel/GetAllPersonel",
          Page: Page,
          Filter: Filter,
        }).then((res) => {
          this.ComboboxUser = res.Data;
          for (var i = 0; i < this.ComboboxUser.length; i++) {
            this.user.push({ id: this.ComboboxUser[i].Id, label: this.ComboboxUser[i].AdSoyad })
          }
        });

      }
    },
    AmacSecimi(donem) {
      let Page = {
        PageNumber: "1",
        PageSize: "9999"
      }
      this.FormDataType.amacid.ComboDataArray = [];
      this.AmacSiralama = [];
      let Filter = "&DonemId=" + donem;

      this.ActionsFilterGet({ "Service": "StrStratejikAmac", "Page": Page, Filter }).then(res => {
        for (var i = 0; i < res.Data.length; i++) {
          this.AmacSiralama.push({ Id: res.Data[i].Id, Value: res.Data[i].Aciklama })

        }
        this.FormDataType.amacid.ComboDataArray = this.AmacSiralama.sort(function (a, b) { return a.Value > b.Value ? 1 : -1; });


      });
    },
    HedefSecimi() {
      let Page = {
        PageNumber: "1",
        PageSize: "9999",
      };
      if (this.FormData.amacid) {
        let Filter = "&AmacId=" + this.FormData.amacid;
        this.ActionsFilterGet({
          Service: "StrPerfTablo",
          Page: Page,
          Filter: Filter,
        }).then((res) => {
          for (var i = 0; i < res.Data.length; i++) {
            this.FormDataType.hedefiid.ComboDataArray.push({
              Id: res.Data[i].Id,
              Value: res.Data[i].Adi + " - " + res.Data[i].Hedefi,
            });
          }
        });
      }
    },
    FaaliyetSecimi() {
      let Page = {
        PageNumber: "1",
        PageSize: "9999",
      };
      let Filter = "&Tip=47&Kod=2";
      this.ActionsFilterGet({ Service: "OKeyValues", Page: Page, Filter: Filter }).then((res) => {
        for (var i = 0; i < res.Data.length; i++) {
          this.FormDataType.faaliyetid.ComboDataArray = [];
          let Filter = "&Tabloids=" + this.FormData.hedefiid + "&GostergeTipiId=" + res.Data[i].Id;
          this.ActionsFilterGet({
            Service: "StrPerfTablolarDetay",
            Page: Page,
            Filter: Filter,
          }).then((res) => {
            for (var i = 0; i < res.Data.length; i++) {
              this.FormDataType.faaliyetid.ComboDataArray.push({
                Id: res.Data[i].Id,
                Value: res.Data[i].Gostergesi,
              });
            }
          });
        }
      });
    },
    IhaleKod(Data) {

      this.ActionsSingleGet({
        Service: "OKeyValues",
        Id: Data,
      }).then((res) => {
        if (18 == res.Data.Kod || 21 == res.Data.Kod || res.Data.Kod == 9 || res.Data.Kod == 10 ||
          11 == res.Data.Kod || res.Data.Kod == 12 || res.Data.Kod == 13 ||
          14 == res.Data.Kod || res.Data.Kod == 15 || res.Data.Kod == 16 || 17 == res.Data.Kod || 19 == res.Data.Kod || 20 == res.Data.Kod) {
          this.ekapNo = false;
        } else {
          this.ekapNo = true;
        }

      });
    },
    yetki_kontrol(yetki) {
      var sonuc = this.KullaniciBilgileri.indexOf(yetki);
      return sonuc;
    },
    loadOptions({ action, callback }) {
      if (action === ASYNC_SEARCH) {

        simulateAsyncOperation(() => {
          this.options = this.hesapkodlari;

          callback(null, this.options)

        })

      }
    },
    loadOptions3({ action, callback }) {
      if (action === ASYNC_SEARCH) {

        simulateAsyncOperation(() => {
          this.options = this.hesapkodlari2;

          callback(null, this.options)

        })

      }
    },
    liste_kontrol() {

      if (this.AddEdit == "Edit") {
        this.hesapkodlari = [];
        this.options = [];
        this.FormDataType.hesapkodu.ComboDataArray = []

        this.hesapkodlari.push({ "id": this.Id.hesapkodu, "label": this.Id.hesapkoduaciklama })
        this.FormDataType.hesapkodu.ComboDataArray.push({ "id": this.Id.hesapkodu, "label": this.Id.hesapkoduaciklama })
        this.options = this.hesapkodlari;
      }
    },
    liste_kontrol2() {

if (this.AddEdit == "Edit") {
  this.hesapkodlari2 = [];
  this.options2 = [];
  this.FormDataType.hesapkodu2.ComboDataArray = []

  this.hesapkodlari2.push({ "id": this.Id.hesapkodu2, "label": this.Id.hesapkoduaciklama2 })
  this.FormDataType.hesapkodu2.ComboDataArray.push({ "id": this.Id.hesapkodu2, "label": this.Id.hesapkoduaciklama2 })
  this.options2 = this.hesapkodlari2;
}
},

    liste_yukle(veri) {
      let Page = {
        PageNumber: "1",
        PageSize: "50",
      };


      if (veri.length >= 1) {
        this.hesapkodlari = [];
        this.aktif_arama = true;

        let Filter = "";

        if (this.ucuncu_duzey) {
          if (veri[0] == "0" && veri[2] == ".") {
            Filter = "&Basamak=3&KodForLike=" + veri;
          } else {

            Filter = "&Basamak=3&Aciklama=" + veri;
          }
        } else {

          if (veri[0] == "0" && veri[2] == ".") {
            Filter = "&Basamak=4&KodForLike=" + veri;
          } else {

            Filter = "&Basamak=4&Aciklama=" + veri;
          }
        }

        this.ActionsFilterGet({ Service: "StrHesapKodlari", Page: Page, Filter: Filter }).then(res => {



          for (var i = 0; i < res.Data.length; i++) {
            this.hesapkodlari.push({ id: res.Data[i].Id, label: res.Data[i].Kod + " - " + res.Data[i].Aciklama })
          }
        });

      }

    },
    liste_yukle2(veri) {
      let Page = {
        PageNumber: "1",
        PageSize: "50",
      };


      if (veri.length >= 1) {
        this.hesapkodlari2 = [];
        this.aktif_arama2 = true;

        let Filter = "";

        if (this.ucuncu_duzey) {
          if (veri[0] == "0" && veri[2] == ".") {
            Filter = "&Basamak=3&KodForLike=" + veri;
          } else {

            Filter = "&Basamak=3&Aciklama=" + veri;
          }
        } else {

          if (veri[0] == "0" && veri[2] == ".") {
            Filter = "&Basamak=4&KodForLike=" + veri;
          } else {

            Filter = "&Basamak=4&Aciklama=" + veri;
          }
        }

        this.ActionsFilterGet({ Service: "StrHesapKodlari", Page: Page, Filter: Filter }).then(res => {



          for (var i = 0; i < res.Data.length; i++) {
            this.hesapkodlari2.push({ id: res.Data[i].Id, label: res.Data[i].Kod + " - " + res.Data[i].Aciklama })
          }
        });

      }

    },
  },
};
</script>
<template>
  <Loader>


    <b-modal id="satdosya" size="lg" :title="this.AddEdit == 'Edit'
        ? $t('satdosya.AddEdit.FormTitleEdit')
        : $t('satdosya.AddEdit.FormTitleAdd')
      " title-class="font-18" hide-footer>
      <Form @submit.prevent="onSubmit">
        <BirimSecimi :title="FormDataType.Ihaleyiyapanmakam.FieldTitle" :sutun="'0'" :title_class="'mb-3'"
          :selected="FormData.ihaleyiyapanmakam" :v="$v.FormData.ihaleyiyapanmakam" :YetkiKontrol="1" :multiple="false"
          :BirimTipId="null" @Secilmis_Idler="FormData.ihaleyiyapanmakam = $event"
          :Disabled="FormData.ihaleyiyapanmakam ? true : false" />


        <forminput :FormDataType="FormDataType.Dosyaadi" :Value="FormData.dosyaadi" :v="$v.FormData.dosyaadi"
          @input="FormData.dosyaadi = $event" />
        <div class="row">
          <div class="col-md-6">
            <formdate :FormDataType="FormDataType.Dosyaacilistarih" :Value="FormData.dosyaacilistarih"
              :v="$v.FormData.dosyaacilistarih" @input="FormData.dosyaacilistarih = $event" />
          </div>
          <div class="col-md-6">

            <formcombobox :FormDataType="FormDataType.Alimturu" :Value="FormData.alimturu" :v="$v.FormData.alimturu"
              @input="FormData.alimturu = $event" />
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <formcombobox :FormDataType="FormDataType.Ihaleturu" :Value="FormData.ihaleturu" :v="$v.FormData.ihaleturu"
              @input="FormData.ihaleturu = $event, IhaleKod($event)" />
          </div>
          <div class="col-md-6" v-if="ekapNo == false">
            <formcombobox :FormDataType="FormDataType.strperfdonem" :Value="FormData.strperfdonem"
              :v="$v.FormData.strperfdonem" @input="FormData.strperfdonem = $event, AmacSecimi($event)" />
          </div>
          <div class="col-md-6" v-if="ekapNo == true">
            <forminput :clas="'text-sm-end'" :FormDataType="FormDataType.ekapno" :Value="FormData.ekapno"
              :v="$v.FormData.ekapno" @input="FormData.ekapno = $event" />
          </div>
        </div>
        <div class="row">
          <div class="col-md-6" v-if="ekapNo == false">
            <formcombobox :FormDataType="FormDataType.amacid" :Value="FormData.amacid" :v="$v.FormData.amacid"
              @input="(FormData.amacid = $event), HedefSecimi()" />
          </div>
          <div class="col-md-6" v-if="ekapNo == false">
            <formcombobox :FormDataType="FormDataType.hedefiid" :Value="FormData.hedefiid" :v="$v.FormData.hedefiid"
              @input="FormData.hedefiid = $event, FaaliyetSecimi()" />
          </div>
        </div>
        <div class="row">
          <div class="col-md-6" v-if="ekapNo == false">
            <formcombobox :FormDataType="FormDataType.faaliyetid" :Value="FormData.faaliyetid"
              :v="$v.FormData.faaliyetid" @input="FormData.faaliyetid = $event" />
          </div>
          <div class="col-md-6" v-if="ekapNo == false">
            <formtextarea :FormDataType="FormDataType.Alimnedeni" :Value="FormData.alimnedeni"
              :v="$v.FormData.alimnedeni" @input="FormData.alimnedeni = $event" />
          </div>
        </div>
        <div class="row">
          <div class="col-md-6" v-if="ekapNo == false">
            <b-form-group class="mb-3" id="example text" :label="FormDataType.gerceklestirmegorevlisiid.FieldTitle"
              label-for="text">
              <treeselect @search-change="user_yukle($event)" :async="aktif_arama" :load-options="loadOptions2"
                :options="FormDataType.gerceklestirmegorevlisiid.ComboDataArray" :multiple="false" :cacheOptions="false"
                searchPromptText="Aramak için yazın..." placeholder="Seçiniz..."
                v-model="FormData.gerceklestirmegorevlisiid" />
              <treeselect-value :value="FormData.gerceklestirmegorevlisiid" />



              <div v-if="$v.FormData.gerceklestirmegorevlisiid.$error" class="invalid-feedback">
                <span v-if="$v.FormData.gerceklestirmegorevlisiid.required == false">{{ $t("ValidationMessage.required")
                  }}</span>
              </div>
            </b-form-group>
          </div>
          <div class="col-md-6" v-if="ekapNo == false">
            <b-form-group class="mb-3" id="example text" :label="FormDataType.harcamagorevlisiid.FieldTitle"
              label-for="text">
              <treeselect :multiple="false" @search-change="user_yukle($event)" :async="aktif_arama"
                :load-options="loadOptions2" :options="FormDataType.harcamagorevlisiid.ComboDataArray"
                placeholder="Seçiniz..." v-model="FormData.harcamagorevlisiid"
                :class="{ 'is-invalid': $v.FormData.harcamagorevlisiid.$error }" />
              <treeselect-value :value="FormData.harcamagorevlisiid" />

              <div v-if="$v.FormData.harcamagorevlisiid.$error" class="invalid-feedback">
                <span v-if="$v.FormData.harcamagorevlisiid.required == false">{{ $t("ValidationMessage.required")
                  }}</span>
              </div>
            </b-form-group>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6" v-if="ekapNo == false">

            <b-form-group class="mb-3" id="example text" label="Bütçe Tertibi" label-for="text">

              <treeselect name="'Hesapkodid'" id="'Hesapkodid'" @search-change="liste_yukle($event)"
                :async="aktif_arama" :load-options="loadOptions" :options="FormDataType.hesapkodu.ComboDataArray"
                :multiple="false" :cacheOptions="false" searchPromptText="Aramak için yazın..." placeholder="Seçiniz..."
                v-model="FormData.hesapkodu" />
              <treeselect-value :value="FormData.hesapkodu" />

              <div v-if="$v.FormData.hesapkodu.$error">
                <span v-if="$v.FormData.hesapkodu.required == false">{{ $t("ValidationMessage.required")
                  }}</span>
              </div>
            </b-form-group>
            </div>
          <div class="col-md-6" v-if="ekapNo == false">
            <formtextarea :FormDataType="FormDataType.Kanunaciklamasi" :Value="FormData.kanunaciklamasi"
              :v="$v.FormData.kanunaciklamasi" @input="FormData.kanunaciklamasi = $event" />
          </div>


          <div class="col-md-6" v-if="ekapNo == false">

            <b-form-group class="mb-3" id="example text" label="İkinci Bütçe Tertibi" label-for="text">

              <treeselect name="'Hesapkodid2'" id="'Hesapkodid2'" @search-change="liste_yukle2($event)"
                :async="aktif_arama2" :load-options="loadOptions3" :options="FormDataType.hesapkodu2.ComboDataArray"
                :multiple="false" :cacheOptions="false" searchPromptText="Aramak için yazın..." placeholder="Seçiniz..."
                v-model="FormData.hesapkodu2" />
              <treeselect-value :value="FormData.hesapkodu2" />

              <div v-if="$v.FormData.hesapkodu2.$error">
                <span v-if="$v.FormData.hesapkodu2.required == false">{{ $t("ValidationMessage.required")
                  }}</span>
              </div>
            </b-form-group>
            </div>
          <div class="col-md-6" v-if="ekapNo == false">


            <formcombobox :FormDataType="FormDataType.Sozlesmeturu" :Value="FormData.sozlesmeturu"
              :v="$v.FormData.sozlesmeturu" @input="FormData.sozlesmeturu = $event" />
          </div>
          <div class="col-md-6" v-if="ekapNo == false">



            <formcombobox :FormDataType="FormDataType.Teklifdegerlendirmeyontem"
              :Value="FormData.teklifdegerlendirmeyontem" :v="$v.FormData.teklifdegerlendirmeyontem"
              @input="FormData.teklifdegerlendirmeyontem = $event" />
          </div>
          <div class="col-md-6">
            <forminput :FormDataType="FormDataType.Dosyasifre" :Value="FormData.dosyasifre" :v="$v.FormData.dosyasifre"
              @input="FormData.dosyasifre = $event" />
          </div>
        </div>

        <div class="row">
          <div class="col-md-6" v-if="ekapNo == false">
            <formcheckbox :title_position="'mt-4'" :labels_lg="6" :FormDataType="FormDataType.Butcedisi"
              :Value="FormData.butcedisi" :v="$v.FormData.butcedisi" @input="FormData.butcedisi = $event" />
          </div>
          <div class="col-md-6">
              <formcheckbox :title_position="'mb-3'" :labels_lg="6"
                :FormDataType="FormDataType.yaklasikmaaliyetbirimfiyat" :Value="FormData.yaklasikmaaliyetbirimfiyat"
                :v="$v.FormData.yaklasikmaaliyetbirimfiyat" @input="FormData.yaklasikmaaliyetbirimfiyat = $event" />
            </div>
        </div>
        <blockquote class="blockquote" v-if="0">
          <p>Web Site Yayınlama Bilgileri</p>
        </blockquote>
        <div class="row" v-if="0">
          <div class="col-md-6">
            <formcheckbox :title_position="'mb-3'" :labels_lg="10" :FormDataType="FormDataType.Yaklasikmaliyetwebsite"
              :Value="FormData.yaklasikmaliyetwebsite" :v="$v.FormData.yaklasikmaliyetwebsite"
              @input="FormData.yaklasikmaliyetwebsite = $event" />
            <formcheckbox :title_position="'mb-3'" :labels_lg="10" :FormDataType="FormDataType.Ihalesonucuwebsite"
              :Value="FormData.ihalesonucuwebsite" :v="$v.FormData.ihalesonucuwebsite"
              @input="FormData.ihalesonucuwebsite = $event" />
          </div>
          <div class="col-md-6">

            <formdate :FormDataType="FormDataType.Yaklasikmaliyetwebsitesontarih"
              :Value="FormData.yaklasikmaliyetwebsitesontarih" :v="$v.FormData.yaklasikmaliyetwebsitesontarih"
              @input="FormData.yaklasikmaliyetwebsitesontarih = $event" />
          </div>
        </div>
        <div class="row">
          <div class="col-md-6" v-if="ekapNo == false">
            <formcheckbox :title_position="'mb-3'" :labels_lg="6" :FormDataType="FormDataType.Cerceveanlasma"
              :Value="FormData.cerceveanlasma" :v="$v.FormData.cerceveanlasma"
              @input="FormData.cerceveanlasma = $event" />
          </div>
          <div class="col-md-6"
            v-if="(yetki_kontrol('SuperAdmin') >= 0 && this.Id.tamamlandi == true) || (this.Id.tamamlandi == false)">
            <formcheckbox :title_position="'mb-3'" :labels_lg="6" :FormDataType="FormDataType.Tamamlandi"
              :Value="FormData.tamamlandi" :v="$v.FormData.tamamlandi" @input="FormData.tamamlandi = $event" />
          </div>
        </div>
        <div class="row">
          <div>

          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <b-form-group id="example text" label="Döküman Ekle" label-for="text" class="mb-3">
              <a v-if="FormData.dosyamalzemebelge" :href="this.$config.FILES_URL +
      'sat/' +
      FormData.dosyamalzemebelge
      " target="_blank">
                Mevcut Dosya
              </a>
              <input class="form-control" ref="file" type="file" v-on:change="FileUpload($event)"
                accept=".doc, .pdf, .xlsx, .dwg" />
            </b-form-group>
          </div>
        </div>



        <button class="btn btn-primary" type="submit">
          {{ $t("satdosya.AddEdit.Button") }}
        </button>
      </Form>
    </b-modal>
  </Loader>
</template>
